import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Mail, Lock } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ChangeEmailDialog({ open, onOpenChange, card, onChanged }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setEmail("");
    setPassword("");
  };

  const handleChange = async () => {
    if (!email.trim() || !password) {
      toast.error("Enter the new email and card password");
      return;
    }
    setLoading(true);
    try {
      await api.post(`/cards/${card.id}/change-email`, { new_email: email.trim(), password });
      toast.success(`Internal account rebound to ${email.trim()}`);
      reset();
      onOpenChange(false);
      onChanged();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Change failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) reset(); onOpenChange(o); }}>
      <DialogContent className="bg-[#121216] border-white/10 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display font-black tracking-tight flex items-center gap-2">
            <Mail className="w-5 h-5 text-[#00F0FF]" /> Change Bound Email
          </DialogTitle>
          <DialogDescription className="text-[#A0A0AB]">
            Rebind internal account <span className="font-mono-sig text-white">{card?.internal_account}</span> to
            another registered email. The internal account itself never changes.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label className="text-[#A0A0AB] text-xs uppercase tracking-wider">New account email</Label>
            <Input
              data-testid="change-email-input"
              placeholder="new.email@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#1A1A20] border-white/10 text-white h-11"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[#A0A0AB] text-xs uppercase tracking-wider">Card password</Label>
            <Input
              data-testid="change-email-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleChange()}
              className="bg-[#1A1A20] border-white/10 text-white h-11 font-mono-sig"
            />
          </div>
          <Button
            data-testid="change-email-submit-button"
            onClick={handleChange}
            disabled={loading}
            className="w-full h-12 bg-[#00F0FF] text-black hover:bg-[#00F0FF]/90 font-semibold rounded-xl"
          >
            <Lock className="w-4 h-4 mr-2" /> {loading ? "Rebinding…" : "Confirm with password"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
